module.exports = __webpack_public_path__ + "static/img/counp3.28cf26b9.png";